import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Modal from './modal.vue'

type IType = 'confirm' | 'operate' | 'upload'

export interface IResultType {
  [key: string]: unknown
  showFooter?: null
}
export const modalProps = buildProps({
  /**
   * @description 开启弹窗
   */
  open: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 标题
   */
  title: {
    type: String,
    default: '提示',
  },
  /**
   * @description 加载状态
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 弹窗类型
   */
  type: {
    type: definePropType<IType>(String),
    default: 'operate',
  },
  isConfirmModel: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 弹窗class
   */
  class: {
    type: String,
    default: '',
  },
  /**
   * @description 弹窗外层容器的类名
   */
  wrapClassName: {
    type: String,
    default: '',
  },
  /**
   * @description 确认按钮文字
   */
  confirmText: {
    type: String,
    default: '',
  },
  /**
   * @description 取消按钮文字
   */
  cancelText: {
    type: String,
    default: '',
  },
  /**
   * @description 显示取消按钮
   */
  showCancel: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 显示底部
   */
  showFooter: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 是否使用esc关闭
   */
  keyboard: {
    type: Boolean,
    default: true,
  },
} as const)

export const modalEmits = {
  /**
   * @description 点击取消时触发
   */
  cancel: () => true,
  /**
   * @description 点击确认时触发
   */
  ok: () => true,
  'update:open': () => true,
} as const

// props
export type ModalProps = ExtractPropTypes<typeof modalProps>

// emits
export type ModalEmits = typeof modalEmits

// instance
export type ModalInstance = InstanceType<typeof Modal>
